import React from "react"
import PropTypes from "prop-types"
import InfoCircleFill from "../../design/assests/images/icons/InfoCircleFill"

/**
 * @typedef {Object} ErrorMessageFormProps
 * @property {string | undefined} className
 * @property {string | undefined} id
 * @property {string} errorMessage
 */
/**
 * @param {ErrorMessageFormProps} props
 * @returns {JSX.Element}
 */
export default function ErrorMessageForm(props) {
  return (
    <span
      className={"flex align-items-center gap-1 " + (props.className || "")}
      id={props.id}
    >
      <InfoCircleFill size={16} color="#F75850" />
      <span>{props.errorMessage}</span>
    </span>
  )
}

ErrorMessageForm.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
}
